<mat-progress-spinner mode="indeterminate" color="accent" [diameter]="50"></mat-progress-spinner>